import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useLocation } from "react-router";
import { ApiService } from "../../components/Common/ApiService";
import Button from "../../components/Common/Button";
import ConditionalRender from "../../components/Common/ConditionalRender";
import ModalBox from "../../components/Common/ModalBox";
import { formatRupiah, useHandleClickLoading, useSessionTimer } from '../../components/Common/utils';

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Input from "../../components/Common/Input";
import { isPending } from "../../store/actions/todoActions";
import InputFormComponent from "./InputFormComponent";
import ModalOrderConfirm from "./ModalOrderConfirm";
import ModalPromo from "./ModalPromo";
import NominalList from "./NominalList";
import PaymentMethodComponent from "./PaymentMethodComponent";

import { ReactComponent as DefenderIcon } from "../../assets/icon/DSADD 1.svg";
import { ReactComponent as DescIcon } from "../../assets/icon/descicon.svg";
import { ReactComponent as UsernameIcon } from "../../assets/icon/gg_profile.svg";
import { ReactComponent as MoneyIcon } from "../../assets/icon/money.svg";

import { ReactComponent as JaminanLayananIcon } from "../../assets/icon/jaminanlayanan.svg";
import { ReactComponent as LayananPelangganIcon } from "../../assets/icon/layananpelanggan.svg";
import { ReactComponent as PembayaranamanIcon } from "../../assets/icon/pembayaranaman.svg";
import { ReactComponent as PengirimaninstanIcon } from "../../assets/icon/pengirimaninstan.svg";
import CheckBox from "../../components/Common/CheckBox";
import useDarkMode from "../../components/Common/darkmode/DarkModeObserver";

function Homepages() {
  const isIdTarget = useSelector(state => state.todoReducer.isIdTarget);
  const isLogin = localStorage.getItem('isLogin');
  const isProfile = localStorage.getItem('isProfile');
  const isWebSetting = localStorage.getItem('isWebSetting');
  const [productData, setProductData] = useState([]);
  const [itemProduct, setItemProduct] = useState([]);
  const [paymentData, setPaymentData] = useState([]);

  const [productLoading, setProductLoading] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(true);

  const [selectedNominalItems, setselectedNominalItems] = useState([]);
  const [selectedPaymentItems, setSelectedPaymentItems] = useState([]);
  const [selectedrekPayment, setselectedrekPayment] = useState([]);
  const [inputForms, setInputForms] = useState([]);
  const [orderConfirm, setOrderConfirm] = useState([]);
  const [jumlahJoki, setJumlahJoki] = useState(1);
  const [inputPromo, setInputPromo] = useState("");
  const [fixPromo, setFixPromo] = useState("");
  const [msgPromo, setMsgPromor] = useState("");
  const [phone, setPhone] = useState("");
  const [hargaFix, setHargaFix] = useState({ harga: 0, logo: "" });
  const [invoice, setInvoice] = useState(0);

  const [isModalDescription, setIsModalDescription] = useState(false);
  const [isModalOrderConfirm, setIsModalOrderConfirm] = useState(false);
  const [isModalCekPromo, setIsModalCekPromo] = useState(false);
  const [isModalCekPromo1, setIsModalCekPromo1] = useState(false);
  const [isModalSuccessTransaction, setIsModalSuccessTransaction] = useState(false);

  const [isModalAds, setisModalAds] = useState(false);
  const [isBantuan, setIsBantuan] = useState("");
  const [isFixed, setIsFixed] = useState(false);
  const targetDivRef = useRef(null);

  const dispatch = useDispatch();
  const isDarkMode = useDarkMode();
  const location = useLocation();
  const handleClickLoading = useHandleClickLoading();

  const [sessionData, startSession] = useSessionTimer('adsLayananSession');
  useEffect(() => {
    fetchDataProduct();
    fetchDataPayment();
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (targetDivRef.current) {
        const rect = targetDivRef.current.getBoundingClientRect();
        const isDivVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

        setIsFixed(isDivVisible);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const parsedObject = JSON.parse(isProfile);
    if (parsedObject?.ponsel) {
      setPhone("+" + parsedObject?.ponsel)
    }
  }, [isProfile]);

  useEffect(() => {
    if (isIdTarget === undefined || isIdTarget === "" || isIdTarget === null) {
      // window.scrollTo(0, 0);
    } else {
      setselectedNominalItems(isIdTarget);
    }
  }, [isIdTarget]);

  const fetchDataProduct = async () => {
    const parsedObject = JSON.parse(isWebSetting);
    setProductLoading(true);
    try {
      const formattedPath = location.pathname.replace("/beli/", "");
      const params = new URLSearchParams();
      params.append("slug", formattedPath);

      const response = await ApiService({
        baseurl: "user/produk",
        method: "POST",
        XGORDON: "PRODUK",
        body: params,
      });
      setProductLoading(false);
      if (response?.statusCode === 200) {
        setProductData(response.result.data);
        setItemProduct(response.result.data?.produk || []);
        setInputForms(response.result.data?.form || []);

        response.result?.data?.status_popup === "1" && !sessionData && setisModalAds(true)
        setIsBantuan(response.result?.data?.bantuan);
        // Mengisi data judul
        const judulMeta = document.querySelector('meta[name="title"]');
        judulMeta.setAttribute(
          "content",
          response.result.data?.meta.title + " - " + parsedObject.judul
        );
        document.title = response.result.data?.meta.title + " - " + parsedObject.judul;
        // Mengisi data deskripsi_meta
        const description = document.querySelector(
          'meta[name="description"]'
        );
        description.setAttribute("content", response.result.data?.meta.deskripsi);
        // Mengisi data keywords
        const keywords = document.querySelector('meta[name="keywords"]');
        keywords.setAttribute("content", response.result.data?.meta.keyword);
        // Mengisi data image
        const images = document.querySelector('meta[name="image"]');
        images.setAttribute("content", response.result.data?.meta.image);

      } else {
        setItemProduct([]);
        setProductData([]);
        setInputForms([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataPayment = async () => {
    const parsedObject = JSON.parse(isLogin);
    setPaymentLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("api_key", parsedObject?.apiKey);

      const response = await ApiService({
        baseurl: "user/pembayaran",
        parameter: (parsedObject ? "auth" : ""),
        method: "POST",
        XGORDON: "PEMBAYARAN",
        body: params,
        apiKey: parsedObject?.apiKey,
        token: parsedObject?.token
      });
      setPaymentLoading(false);
      if (response?.statusCode === 200) {
        setPaymentData(response.result.data);
      } else {
        setPaymentData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchchekPromo = async () => {
    dispatch(isPending(true));
    try {
      const params = new URLSearchParams();
      params.append("id_kategori", productData.id);
      params.append("kode_promo", inputPromo);

      const response = await ApiService({
        baseurl: "user/cek_promo",
        method: "POST",
        XGORDON: "CEKPROMO",
        body: params,
      });
      dispatch(isPending(false));
      if (response?.statusCode === 200) {
        toggleModalCekPromo1()
        setMsgPromor(response?.result.msg)
      } else {
        toggleModalCekPromo()
        setFixPromo('');
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getOrderConfirm = async () => {
    dispatch(isPending(true));
    const transformedDatalayanan = { layanan: selectedNominalItems.id };
    const transformedDataPayment = { metode: selectedPaymentItems.id };
    const transformedDatainput = inputForms.reduce((result, item) => {
      result[item.name] = item.value;
      return result;
    }, {});
    const transformedDataJumlah = productData.is_joki === "1" && { jumlah: jumlahJoki };
    const transformedDataVoucher = fixPromo === "" ? null : { promo_voucher: fixPromo };
    const transformedDataKontak = { kontak: phone.replace('+62', '0') };
    const transformedDataphonePayment =
      selectedrekPayment?.length === 0
        ? null
        : selectedrekPayment[0].nama === "Saldo"
          ? { pintrx: selectedrekPayment[0].value }
          : { rek: selectedrekPayment[0].value };
    // Menggabungkan semua objek menjadi satu objek tunggal
    const combinedData = {
      ...transformedDatalayanan,
      ...transformedDataPayment,
      ...transformedDatainput,
      ...transformedDataJumlah,
      ...transformedDataVoucher,
      ...transformedDataKontak,
      ...transformedDataphonePayment,
    };
    const parsedObject = JSON.parse(isLogin);
    try {
      const params = new URLSearchParams();
      for (const key in combinedData) {
        params.append(key, combinedData[key]);
      }
      params.append("api_key", parsedObject?.apiKey);

      const response = await ApiService({
        baseurl: "user/" + (parsedObject ? "orderConfirm" : "orderConfirmGuest"),
        method: "POST",
        XGORDON: (parsedObject ? "ORDERCONFIRM" : "ORDERCONFIRMGUEST"),
        body: params,
        apiKey: parsedObject?.apiKey,
        token: parsedObject?.token
      });
      dispatch(isPending(false));
      if (response?.statusCode === 200) {
        setOrderConfirm(response.result.data);
        toggleModalOrderConfirm();
      } else {
        toast.error(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setOrderConfirm([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const setOrderFix = async (tokenSHA) => {
    dispatch(isPending(true));
    const transformedDatalayanan = { layanan: selectedNominalItems.id };
    const transformedDataPayment = { metode: selectedPaymentItems.id };
    const transformedDatainput = inputForms.reduce((result, item) => {
      result[item.name] = item.value;
      return result;
    }, {});
    const transformedDataJumlah = productData.is_joki === "1" && { jumlah: jumlahJoki };
    const transformedDataVoucher = fixPromo === "" ? null : { promo_voucher: fixPromo };
    const transformedDataKontak = { kontak: phone.replace('+62', '0') };
    const transformedDataphonePayment =
      selectedrekPayment?.length === 0
        ? null
        : selectedrekPayment[0].nama === "Saldo"
          ? { pintrx: selectedrekPayment[0].value }
          : { rek: selectedrekPayment[0].value };
    // Menggabungkan semua objek menjadi satu objek tunggal
    const combinedData = {
      ...transformedDatalayanan,
      ...transformedDataPayment,
      ...transformedDatainput,
      ...transformedDataJumlah,
      ...transformedDataVoucher,
      ...transformedDataKontak,
      ...transformedDataphonePayment,
    };
    const parsedObject = JSON.parse(isLogin);
    try {
      const params = new URLSearchParams();
      for (const key in combinedData) {
        params.append(key, combinedData[key]);
      }
      params.append("api_key", parsedObject?.apiKey);

      const response = await ApiService({
        baseurl: "user/" + (parsedObject ? "order" : "orderGuest"),
        method: "POST",
        customHeaders: { "x-gorgon": tokenSHA },
        body: params,
        apiKey: parsedObject?.apiKey,
        token: parsedObject?.token
      });
      dispatch(isPending(false));

      if (response?.statusCode === 200) {
        toggleModalOrderConfirm();
        toggleModalSuccessTransaction();
        setInvoice(response?.result.invoice);
      }
      else if (response?.statusCode === 400) {
        toast.error(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      else {
        toast.error(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const toggleModalDescription = () => {
    setIsModalDescription(!isModalDescription);
  };
  const toggleModalOrderConfirm = () => {
    setIsModalOrderConfirm(!isModalOrderConfirm);
  };
  const toggleModalCekPromo = () => {
    setIsModalCekPromo(!isModalCekPromo);
  };
  const toggleModalCekPromo1 = () => {
    setIsModalCekPromo1(!isModalCekPromo1);
  };
  const toggleModalSuccessTransaction = () => {
    setIsModalSuccessTransaction(!isModalSuccessTransaction);
  };


  const newLocal = <div className="grid md:grid-cols-4 grid-cols-2 gap-2">
    <div className="flex flex-row gap-1 items-center">
      <LayananPelangganIcon className="w-5 h-5" fill={'#ffffff'} />
      <span className="text-xs sm:text-darkColor text-lightColor">
        Layanan Pelanggan 24/7
      </span>
    </div>
    <div className="flex flex-row gap-1 items-center">
      <PembayaranamanIcon className="w-5 h-5" fill={'#ffffff'} />
      <span className="text-xs  sm:text-darkColor text-lightColor">
        Pembayaran yang Aman
      </span>
    </div>
    <div className="flex flex-row gap-1 items-center">
      <JaminanLayananIcon className="w-5 h-5" fill={'#ffffff'} />
      <span className="text-xs sm:text-darkColor text-lightColor ">
        Jaminan Layanan
      </span>
    </div>
    {productData?.is_manual === "0" && (
      <div className="flex flex-row gap-1 items-center">
        <PengirimaninstanIcon className="w-5 h-5" fill={'#ffffff'} />
        <span className="text-xs sm:text-darkColor text-lightColor">
          Pengiriman Instant
        </span>
      </div>
    )}
  </div>;
  const newLocal1 = <div className="grid grid-cols-2 gap-2">
    <div className="flex flex-row gap-1 items-center">
      <LayananPelangganIcon className="w-5 h-5" fill={'#212121'} />
      <span className="text-xs  text-lightColor">
        Layanan Pelanggan 24/7
      </span>
    </div>
    <div className="flex flex-row gap-1 items-center">
      <PembayaranamanIcon className="w-5 h-5" fill={'#212121'} />
      <span className="text-xs   text-lightColor">
        Pembayaran yang Aman
      </span>
    </div>
    <div className="flex flex-row gap-1 items-center">
      <JaminanLayananIcon className="w-5 h-5" fill={'#212121'} />
      <span className="text-xs  text-lightColor ">
        Jaminan Layanan
      </span>
    </div>
    {productData?.is_manual === "0" && (
      <div className="flex flex-row gap-1 items-center">
        <PengirimaninstanIcon className="w-5 h-5" fill={'#212121'} />
        <span className="text-xs  text-lightColor">
          Pengiriman Instant
        </span>
      </div>
    )}
  </div>;
  return (
    <div className="flex flex-col gap-3 flex-1">
      <div className="relative flex flex-col  lg:rounded-lg rounded-none bg-cardLight dark:bg-cardDark overflow-clip gap-2">
        <ConditionalRender
          productsData={productData}
          isLoading={productLoading}
          model={"emptyData"}
        >
          <div className="flex flex-col flex-1 relative">
            <LazyLoadImage
              src={productData.background}
              alt={productData.nama}
              className=" object-cover w-full h-full xl:aspect-[4/1] sm:aspect-[3/1] aspect-[2/1] "
              effect="blur"
            />
          </div>
        </ConditionalRender>
        <div className="absolute sm:flex hidden gap-2 p-3 flex-row bg-[#22BDE2] bottom-0 w-full">
          <LazyLoadImage
            src={productData?.gambar}
            alt={productData?.nama}
            height={"100%"}
            className="rounded-lg w-40  aspect-square object-cover  -mt-20"
            effect="blur"
          />
          <div className="flex flex-1  flex-col justify-end">
            <span className="text-2xl font-bold text-left line-clamp-1 italic text-darkColor">
              {productData.nama}
            </span>
            {newLocal}

          </div>
        </div>

        <div className="relative sm:hidden flex flex-row  lg:rounded-lg rounded-none bg-cardLight dark:bg-cardDark p-3 gap-2">
          <LazyLoadImage
            src={productData?.gambar}
            alt={productData?.nama}
            height={"100%"}
            className="rounded-lg w-20  aspect-square object-cover "
            effect="blur"
          />
          <div className="flex flex-1 gap-2 flex-col justify-end">
            <span className="text-2xl font-bold text-left line-clamp-1 italic ">
              {productData.nama}
            </span>
            {newLocal1}
            <div className="relative flex flex-col  lg:rounded-lg rounded-none bg-cardLight dark:bg-cardDark gap-2">
              <div className="flex sm:flex-row flex-col items-end gap-2">
                <div className="prose flex-1 gap-3 flex flex-col">
                  <div
                    dangerouslySetInnerHTML={{ __html: productData.detail }}
                    className={`text-sm lg:line-clamp-[10] md:line-clamp-4 `}
                  />
                </div>
                <Button
                  initialValue="Cara Pembelian"
                  iconLeft={<DescIcon />}
                  type="fill"
                  color={"#ffffff"}
                  className="bg-[#2196F3] text-darkColor text-xs h-8"
                  onClick={() => toggleModalDescription()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative hidden sm:flex flex-col shadow-inner lg:rounded-lg rounded-none bg-cardLight dark:bg-cardDark p-3 gap-2">
        <div className="flex sm:flex-row flex-col items-end gap-2">
          <div className="prose flex-1 gap-3 flex flex-col">
            <div
              dangerouslySetInnerHTML={{ __html: productData.detail }}
              className={`text-sm lg:line-clamp-[10] md:line-clamp-4 `}
            />
          </div>
          <Button
            initialValue="Cara Pembelian"
            iconLeft={<DescIcon />}
            type="fill"
            color={"#ffffff"}
            className="bg-[#2196F3] text-darkColor text-xs h-8"
            onClick={() => toggleModalDescription()}
          />
        </div>
      </div>

      {productData.deskripsi_game === "<p></p>\n" || productData.deskripsi_game === "" ? null :
        <div className=" flex-col rounded-lg  shadow-inner sm:flex  bg-cardLight dark:bg-cardDark">
          <div className="flex flex-col gap-2 p-3">
            <span className="text-2xl font-bold text-left line-clamp-1 italic ">
              Deskripsi Game
            </span>
            <div className="prose rounded-md ">
              <div
                dangerouslySetInnerHTML={{ __html: productData.deskripsi_game }}
                className={`text-sm `}
              />
            </div>
          </div>
        </div>
      }
      <div className="flex sm:flex-row flex-col gap-3 px-3">
        <div className="flex flex-col gap-2 flex-1  relative">
          <div className="flex flex-col gap-2  sticky top-2">

            <InputFormComponent
              className="flex sm:hidden "
              inputForms={inputForms}
              productLoading={productLoading}
              setInputForms={setInputForms}
              productData={productData}
              isBantuan={isBantuan}
            />

            <NominalList
              itemProduct={itemProduct}
              productLoading={productLoading}
              selectedNominalItems={selectedNominalItems}
              setselectedNominalItems={setselectedNominalItems}
              setSelectedPaymentItems={setSelectedPaymentItems}
              inputForms={inputForms}
            />

          </div>
        </div>
        <div className="flex flex-col gap-3 basis-5/12" >
          <InputFormComponent
            className="sm:flex hidden"
            inputForms={inputForms}
            productLoading={productLoading}
            setInputForms={setInputForms}
            productData={productData}
            isBantuan={isBantuan}
          />
          <div className="flex flex-col rounded-lg shadow-inner bg-cardLight dark:bg-cardDark" >
            <div className="flex flex-row items-center gap-1 rounded-md  bg-[#22BDE2] text-darkColor">
              <div className=' items-center justify-center flex rounded-md bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  p-3 h-12 w-12 '>
                <span className="font-bold">
                  {inputForms.length !== 0 ? "3" : "2"}
                </span>
              </div>
              <span className="text-base px-3 font-medium line-clamp-1">
                Data Pemesan
              </span>
            </div>
            <div className="flex flex-col justify-between rounded-b-lg gap-2 p-3 ">
              <Input
                id="phone"
                label={'Nomor WhatsApp'}
                icon={<UsernameIcon />}
                name={'phone'}
                value={phone}
                onChange={(value) => setPhone(value)}
                type={"tel"}
                bgcolor={"bg-[#edeeee]"}
                placeholder={'Masukan Nomor WhatsApp'}
              />
              <Input
                id="promo"
                label={'Masukan Kode Promo'}
                name={'promo'}
                value={inputPromo}
                onChange={(value) => setInputPromo(value)}
                type={"promo"}
                bgcolor={"bg-[#edeeee]"}
                disabled={inputPromo && fixPromo === inputPromo ? true : false}
                OnSubmit={() => {
                  if (fixPromo === inputPromo) {
                    setInputPromo("");
                    setFixPromo("");
                  } else {
                    fetchchekPromo(inputPromo);
                  }
                }}

                placeholder={'Masukan Promo'}
              />
            </div>

            <div className="flex flex-row gap-2 bg-[#E7F3FE] rounded-lg p-2 items-center m-3 mt-0">
              <DescIcon className="w-6 h-6 " fill="#0D47A1" />
              <span className="text-[#0D47A1] text-xs flex-1">
                Redeem Promo Voucher yang kamu punya buat klaim hadiah. Jika
                tidak punya Gift Voucher, kamu bisa transaksi lewat tab Pembelian.
              </span>
            </div>
          </div>
          <div id="payment">
            <div className="flex flex-col rounded-lg min-h-[200px] gap-2 pb-3 shadow-inner bg-cardLight dark:bg-cardDark">
              <div className="flex flex-row items-center gap-1 rounded-md  bg-[#22BDE2] text-darkColor">
                <div className=' items-center justify-center flex rounded-md bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  p-3 h-12 w-12 '>
                  <span className="font-bold">
                    {inputForms.length !== 0 ? "4" : "3"}
                  </span>
                </div>
                <span className="text-base px-3 font-medium line-clamp-1">
                  Pilih Metode Pembayaran
                </span>
              </div>
              <PaymentMethodComponent
                paymentData={paymentData}
                paymentLoading={paymentLoading}
                selectedNominalItems={selectedNominalItems}
                selectedPaymentItems={selectedPaymentItems}
                selectedrekPayment={selectedrekPayment}
                setSelectedPaymentItems={setSelectedPaymentItems}
                setselectedrekPayment={setselectedrekPayment}
                hargaFix={setHargaFix}
                type_payment={'product'}
              />
            </div>
          </div>
          {productData.is_joki === "1" && (
            <div className="flex flex-col rounded-lg shadow-inner bg-cardLight dark:bg-cardDark" >
              <div className="flex flex-row items-center gap-1 rounded-md  bg-[#22BDE2] text-darkColor">
                <div className=' items-center justify-center flex rounded-md bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  p-3 h-12 w-12 '>
                  <span className="font-bold">
                    5
                  </span>
                </div>
                <span className="text-base px-3 font-medium line-clamp-1">
                  Input Jumlah
                </span>
              </div>
              <div className="flex flex-row justify-between rounded-b-lg gap-2 p-3 ">
                <Input
                  id="jumlah_joki"
                  label={'Masukan Jumlah'}
                  name={'jumlah_joki'}
                  value={jumlahJoki}
                  onChange={(event) => {
                    const inputValue = event;
                    const numericValue = inputValue.replace(/\D/g, "");
                    const validValue = Math.min(Number(numericValue), 1000);
                    setJumlahJoki(validValue.toString());
                  }}
                  OnSubmit1={() => {
                    setJumlahJoki(parseInt(jumlahJoki) + 1)
                  }}
                  OnSubmit={() => {
                    setJumlahJoki(
                      parseInt(jumlahJoki) <= 1
                        ? jumlahJoki
                        : jumlahJoki - 1
                    )
                  }}
                  type={"jumlah_joki"}
                  bgcolor={"bg-[#edeeee]"}
                  placeholder={'Masukan Jumlah'}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div ref={targetDivRef} />
      {selectedPaymentItems.length !== 0 &&
        <div className={`bg-cardLight dark:bg-cardDark  ${!isFixed && " fixed left-0 right-0 bottom-0 "}`}>
          <div className="flex sm:flex-row flex-col justify-between lg:rounded-lg gap-2 p-3 shadow-inner">
            <div className="flex flex-col justify-center">
              <span className=" text-base text-[#22BDE2]  font-semibold">{selectedNominalItems?.layanan}</span>
              <span className="text-base"> {formatRupiah(hargaFix.harga * jumlahJoki)}</span>
            </div>
            <div className="flex flex-col items-center gap-2 sm:items-end ">
              <Button
                initialValue="Lanjutkan Pembayaran"
                iconLeft={<MoneyIcon />}
                type="fill"
                color={'#ffffff'}
                className="bg-[#22BDE2] w-full text-darkColor"
                onClick={() => {
                  const phoneRegex = /^\+62\d{8,17}$/;
                  if (selectedNominalItems.length === 0) {
                    toast.error("Layanan Belum Dipilih", {
                      position: toast.POSITION.TOP_RIGHT,
                    });
                  }
                  else if (selectedPaymentItems.length === 0) {
                    toast.error("Metode Pembayaran Belum Dipilih", {
                      position: toast.POSITION.TOP_RIGHT,
                    });
                  }
                  else if (!phoneRegex.test(phone)) {
                    toast.error("Nomor telepon tidak valid. Mohon periksa masukan Anda.", {
                      position: toast.POSITION.TOP_RIGHT,
                    });
                  }
                  else if (selectedPaymentItems.pake_rek === "1") {
                    if (selectedrekPayment[0].nama === "Saldo") {
                      if (selectedrekPayment[0].value.length < 6) {
                        toast.error(`PIN pada Pembayaran ${selectedrekPayment[0].nama} tidak valid. Mohon periksa masukan Anda.`, {
                          position: toast.POSITION.TOP_RIGHT,
                        });
                      } else {
                        getOrderConfirm();
                      }
                    } else {
                      if (!phoneRegex.test(selectedrekPayment[0].value)) {
                        toast.error(`Nomor WhatsApp pada Pembayaran ${selectedrekPayment[0].nama} tidak valid. Mohon periksa masukan Anda.`, {
                          position: toast.POSITION.TOP_RIGHT,
                        });
                      } else {
                        getOrderConfirm();
                      }
                    }
                  } else {
                    getOrderConfirm();
                  }
                }}
              />
              <div className="flex flex-row gap-2 items-center">
                <DefenderIcon />
                <span className=" text-xs flex-1">Pembayaran anda terjamin aman </span>
              </div>
            </div>
          </div>
        </div>}
      <ModalBox active={isModalSuccessTransaction} onClose={toggleModalSuccessTransaction}>
        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-center">
            <img className="flex w-[50%]"
              src={require("../../assets/images/successTransaction.gif")}
              alt="promo not found"
            />
          </div>
          <div className="flex flex-col">
            <span
              className={` text-lg font-semibold `}
            >
              Transaksi Berhasil!
            </span>
            <span
              className={` text-sm opacity-60`}
            >
              Periksa halaman transaksi anda untuk info lebih lanjut
            </span>
          </div>
          <div className="flex flex-row gap-2">
            <Button
              initialValue="Lihat Invoice"
              type="fill"
              className="bg-[#22BDE2] text-darkColor w-full"
              onClick={() => {
                toggleModalSuccessTransaction();
                handleClickLoading('/invoice/' + invoice)
              }}
            />
          </div>
        </div>
      </ModalBox>

      <ModalPromo
        productData={productData}
        inputPromo={inputPromo}
        setFixPromo={setFixPromo}
        msgPromo={msgPromo}

        isModalCekPromo={isModalCekPromo}
        toggleModalCekPromo={toggleModalCekPromo}
        isModalCekPromo1={isModalCekPromo1}
        toggleModalCekPromo1={toggleModalCekPromo1}
        isModalDescription={isModalDescription}
        toggleModalDescription={toggleModalDescription}
      />

      <ModalOrderConfirm
        active={isModalOrderConfirm}
        onClose={toggleModalOrderConfirm}
        productData={productData}
        orderConfirm={orderConfirm}
        setOrderFix={setOrderFix}
        type={'product'}
      />

      <ModalBox active={isModalAds} onClose={() => setisModalAds(false)}>
        <div
          className="text-sm max-w-lg"
          dangerouslySetInnerHTML={{ __html: productData.popup }}
        />
        <CheckBox
          label="Jangan Tampilkan Lagi"
          onChange={(event) => {
            if (event) {
              setisModalAds(false)
              startSession(true);
            }
          }}
        />
      </ModalBox>
    </div>
  );
}

export default Homepages;
